import { emptyTheme, useMUITheme } from '@olympeio/core';
import { BrickContext } from 'olympe';
import { useEffect, useState } from 'react';
import { Theme as MUITheme, createTheme } from '@mui/material';

/**
 * Wrap `observeMUITheme` and provides extra opinionated defaults
 * @param {BrickContext} $
 * @return {Observable<MUITheme>}
 *
 */
/**
 * Wrap `useMUITheme` and provides extra opinionated defaults
 *
 * @param {!BrickContext} $
 * @return {MUITheme} a stateful value usable in JSX
 */
export function useOlympeTheme($: BrickContext): MUITheme {
    const [value, setValue] = useState(emptyTheme);
    const theme = useMUITheme($);
    useEffect(() => {
        const newTheme = createTheme(theme);
        newTheme.typography.h1.fontSize = '2.125rem';
        newTheme.typography.h2.fontSize = '1.875rem';
        newTheme.typography.h3.fontSize = '1.625rem';
        newTheme.typography.h4.fontSize = '1.375rem';
        newTheme.typography.h5.fontSize = '1.125rem';
        newTheme.typography.h6.fontSize = '1rem';
        newTheme.typography.body1.fontSize = '1rem';
        newTheme.typography.body2.fontSize = '1rem';
        setValue(newTheme);
    }, [theme]);
    return value;
}